import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'admin'

const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if (userInfo && userInfo.user_info.userRole) initialRole = userInfo.user_info.userRole

if (initialRole == 'isStaff') { initialRole = 'nh_staff' }
if (initialRole == 'isUser') { initialRole = 'user' }
if (initialRole == 'isNursingHomeAdmin') { initialRole = 'nh_admin' }
if (initialRole == 'isAdmin') { initialRole = 'admin' }
console.log(`user_role :${  initialRole}`)


export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    admin  : new AclRule('admin').generate(),
    nh_admin : new AclRule('nh_admin').generate(),
    nh_staff : new AclRule('nh_staff').generate(),
    user : new AclRule('user').generate(),
    onlyAdmins : new AclRule('nh_admin').or('admin').generate(),
    public: new AclRule('nh_admin').or('admin').or('nh_staff').or('user').generate()
  }
})
